import React, {useContext, useEffect, useState} from "react";
import API from "../components/api/api";
import "./user_status.css"
import {Context} from "./utils/store";

const UserStatus = () => {

    const [state, dispatch] = useContext(Context);
    const api = API("live")

    const loadUser = async() => {
        const response = await api.getUser()
        console.log(response)
        if(response.email) {
            dispatch({type:'LOGIN_USER', payload:response})
        } else {
            dispatch({type:'LOGOUT_USER'})
        }
    }

    useEffect( () => {
        loadUser()
    },[])

    console.log(state.user)
    return <div className={"userStatus"}>
        {state.user && state.user.isAuthenticated ?
            <span>
                <img style={{backgroundImage: `url(${state.user.picture})` }} className={"avatar"}/>
                Hello, {state.user.name}!
                <a href="/api/logout" className={"button"}>log out </a>
            </span>
            :
            <span>
                <img style={{backgroundImage: `url(${state.user.picture})` }} className={"avatar"}/>
                <a href="/api/login" className={"button"}>log in</a>
            </span>
        }
    </div>
}

export default UserStatus
